/**
 * The ProductFilter allows filtering based on the id of the given
 * fields below.
 */

import { FilterCategory } from './filtercategory';

export class ProductFilter {

  category: number[];
  color: number[];
  collection: number[];
  brand: number[];
  fabric: number[];
  size: number[];
  query: string;
  tag: string;
  limit: number;
  vendor: string;
  ordering: string;
  page: number;

  defaults: Map<string, any>;

  constructor() {

    var that = this;

    this.defaults = new Map<string, any>(
      [
        ['color', []],
        ['collection', []],
        ['category', []],
        ['size', []],
        ['brand', []],
        ['fabric', []],
        ['query', ""],
        ['tag', ""],
        ['limit', -1],
        ['ordering', ""],
        ['vendor', ""],
        ['page', 1]
      ]
    );

    this.defaults.forEach(
      (val, key, map) =>
        { that[key] = val; }
    );
  }

  /**
   * Set filter defined by name to value. This will add to existing
   * values.
   */
  setval(name: string, value: any): void {

    if (this[name] == undefined) {
      return;
    }

    if (typeof this[name] == 'string') {
      this[name] = String(value);
    } else if (typeof this[name] == 'number') {
      this[name] = +value;
    } else {
      // assume it's an array
      // extend the array with the new item if not already existing!
      let numVal = +value;  // use +value to cast to number
      if (!this[name].includes(numVal)) {
        this[name].push(+value);  // use +value to cast to number
        // create a copy of the array so angular will detect change
        this[name] = this[name].slice();
      }
    }
  }

  public unsetval(name: string, value: number) {

    if (this[name] == undefined) {
      return;
    }

    if (typeof this[name] == 'string' || typeof this[name] == 'number') {
      this.clear(name);
    } else {
      // assume it's an array

      // use +value to cast to number
      this[name].splice(this[name].indexOf(+value), 1);
      // create a copy of the array so angular will detect change
      this[name] = this[name].slice();
    }
  }

  public hasval(name: string): boolean {

    return this[name] != this.defaults.get(name);
  }

  public clear(name: string) {

    if (typeof this[name] == 'string' || typeof this[name] == 'number') {
      this[name] = this.defaults.get(name);
    } else {
      this[name] = this.defaults.get(name).slice(0);
    }
  }

  keys(): string[] {
    return ['query', 'color', 'collection', 'category', 'brand', 'fabric',
            'size', 'tag', 'limit', 'vendor', 'ordering', 'page'];
  }

  public clearAll(): void {
    for (let k of this.keys()) {

      this.clear(k);
    }
  }

  /**
   * Set filter values from URL.
   */
  setValuesFromURL(url: string): void {

    var qs = url.split('#')[0].split("?")[1];

    if (qs) {
      var parts = qs.split('&');

      for (var i = 0; i < parts.length; i++) {
        var param = parts[i].split('=');
        this.setval(param[0], param[1]);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Models/filter.ts